import { Tabs, Toolbar } from '@material-ui/core';
import * as React from 'react';

export interface VoxelPageContainerProps {
  excludeAppBar?: boolean;
  className?: string;
  paddingTopClass?: string;
  maxWidthClass?: string;
}

const VoxelPageContainer: React.FC<VoxelPageContainerProps> = ({
  children,
  excludeAppBar,
  className,
  paddingTopClass = 'pt-24',
  maxWidthClass: maxWidthClasses = 'container',
}) => {
  return (
    <div className={`${maxWidthClasses} mx-auto p-8 ${paddingTopClass} ${className}`}>
      {!excludeAppBar && (
        <>
          <Toolbar />
          <Tabs value={1} />
        </>
      )}
      {children}
    </div>
  );
};

export default VoxelPageContainer;
